/*
 * commons共通套件
 * 依赖：
 * "iview": "^3.0.1",
 * "axios": "^0.18.0",
 * "moment": "^2.22.1",
 * "sockjs-client": "^1.1.5",
 * "stompjs": "^2.3.3"
 *
 * 1）【必须】 store：套件依赖的store，“必须”在项目store中导入
 *    import { store as CommonsStore } from 'commons'
 *    import store from 'commons/store'
 *
 * 2）【必须】 style：共通css，“必须”在项目中导入
 *    import 'commons/style'
 *
 * 3）[重要] components：组件库，各种共通组件目录
 *    import { <name> } from 'commons'
 *    import { <name> } from 'commons/components'
 *
 * 4）[重要] locale：共通依赖的语言包，“必须”与项目的localStorage使用相同的key：“LANG”
 *    import { <name> } from 'commons/locale'
 *
 * 5）(可选) utils：工具类，commons共通所依赖的工具方法，可自行选择引用
 *    import { <name> } from 'commons/utils'
 *
 * 6）(可选) domain：接口外链地址列表，可通过$ComDomain直接使用
 *    $ComDomain
 *    import domain from 'commons/store/domain'
 *
 * 7）【必须】 config：webpack配置文件，正确添加以下配置项
 *    PUBLIC_PATH、API_Print、API_Market
 *    代码示例：
 *
 *    const config = require('../config')
 *    module.exports = {
 *      NODE_ENV: '"production"',
 *      PUBLIC_PATH: JSON.stringify(config.build.assetsPublicPath),
 *      API_Print: '"/api/mall"',
 *      API_Market: '"/api/print"'
 *    }
 *
 *    PUBLIC_PATH：用于指向静态资源在服务器上的根目录
 *    config.assetsPublicPath：服务器上静态资源根目录
 *    router.base：路由的跟目录
 *    PUBLIC_PATH，config.assetsPublicPath，router.base 三者最好保持一致
 *
 */
import Vue from 'vue'
import Axios from 'axios'
import store from './store'
import domain from './store/domain'
import { Message, Modal } from 'iview'

global.$Message = Message
global.$Modal = Modal

Vue.prototype.$ComDomain = global.$ComDomain = domain

// http request 拦截器
global.$ComAxios = Axios.create()
global.$ComAxios.interceptors.request.use(
  config => {
    config.withCredentials = true
    config.url = config.url.replace(/^(?:(\w+):)?(.*)$/, (pattern, domain, url) => {
      config.baseURL = global.$ComDomain.Boot[domain || 'user']
      return url
    })
    config.headers.post['Content-Type'] = 'application/json'
    config.headers.common['token'] = window.localStorage.getItem('Authorization')
    if (config.method == 'get') {
      config.params = {
        t: new Date().getTime(),
        ...config.params
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

global.$ComAxios.interceptors.response.use((response) => {
  return response
}, (error) => {
  console.log(error)
  if (error.response && error.response.status == 401) {
    Vue.$store.dispatch('logout')
  }
  return Promise.reject(error)
})

export * from './components'

export {
  store
}



// WEBPACK FOOTER //
// ./src/commons/index.js